<template>

    <div class="nav-tabs-custom">
        <div class="tab-content">
            <div class="tab-pane active">
                <server-table
                    v-if="loaded"
                    :add-url="route('documents.add.index', {}, false)"
                    :data-url="st.url"
                    :data-columns="JSON.stringify(st.columns)"
                    :preference-url="st.preferenceUrl"
                    :templates-uri="route('api.v1.templates.index')"
                ></server-table>
            </div>
        </div>
    </div>

</template>

<script>

import ServerTable from "../../components/Documents/ServerTable";
import axios from "axios";

export default {

    components: {
        ServerTable,
    },

    data() {
        return {
            loaded:false,
            st: {
                columns:[],
                url:'',
                preferenceUrl:'',
            }
        }
    },

    metaInfo: {
        title:'Documents',
    },

    methods: {
        getDocumentsData() {
            axios.get(this.route('api.v1.documents.st'))
            .then(resp => {
                this.st = resp.data;
                this.loaded = true;
            })
        }
    },

    mounted() {
        this.getDocumentsData();
    },

    name:'DocumentsIndex',

}

</script>
